import { formatDistanceToNow } from 'date-fns'

export default function ago(val) {
  return formatDistanceToNow(new Date(val), { addSuffix: true })
}
